import { cn } from '@utils/cn';
import { RevealProps } from './types';

export const Reveal = ({ show, children, className, contentClassName }: RevealProps) => (
  <div
    aria-hidden={!show}
    className={cn(
      'grid transition-[grid-template-rows,opacity] duration-200 ease-out motion-reduce:transition-none',
      show ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0',
      className,
    )}>
    <div className="min-h-0 overflow-hidden">
      <div className={contentClassName}>{children}</div>
    </div>
  </div>
);
